export default __webpack_public_path__ + "static/media/ic_banxa.6f6d2427.svg";